import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";
import { buildLegalLd } from "@/lib/page-schemas";

export const Route = createFileRoute("/disclaimer")({
  head: () => ({
    meta: [
      { title: "Disclaimer — DrHint (Asset & Utility Shield)" },
      { name: "description", content: "Financial and utility-services disclaimers covering all DrHint gold, silver, loan EMI and bill-lookup tools." },
      { name: "robots", content: "index,follow,max-snippet:-1" },
      { property: "og:url", content: "https://drhint.com/disclaimer" },
    ],
    links: [{ rel: "canonical", href: "https://drhint.com/disclaimer" }],
    scripts: buildLegalLd({
      url: "https://drhint.com/disclaimer",
      name: "Disclaimer — DrHint",
      description: "Financial and utility-services disclaimers covering all DrHint gold, silver, loan EMI and bill-lookup tools.",
      lastModified: "2026-06-16",
      trail: [
        { name: "Home", item: "https://drhint.com/" },
        { name: "Disclaimer", item: "https://drhint.com/disclaimer" },
      ],
    }),
  }),
  component: () => (
    <Layout>
      <article className="mx-auto max-w-3xl px-4 py-10 text-sm leading-relaxed">
        <h1 className="text-3xl font-bold">Disclaimer</h1>
        <p className="mt-2 text-xs text-muted-foreground">The Asset &amp; Utility Shield · Last updated: 16 June 2026</p>

        <p className="mt-6 text-muted-foreground">
          The information provided on DrHint is for general informational and
          educational purposes only. The sections below cover each functional
          silo on the platform: financial (gold, silver, loan EMI) and
          utility (bill lookup).
        </p>

        <h2 className="mt-8 text-xl font-bold">A. Financial Disclaimer — Gold, Silver &amp; Loan EMI</h2>
        <p className="mt-2 text-muted-foreground">
          All live Gold and Silver (Chandi) rates displayed on DrHint, alongside
          all Loan EMI, interest-saver and amortization payoff calculations, are
          programmatically derived informational estimations intended for
          educational use only. They are computed from international spot
          prices, public foreign-exchange feeds, and standard country/city
          premium models, and may differ from the figure your local jeweller,
          bullion association or bank ultimately quotes.
        </p>
        <p className="mt-2 text-muted-foreground">
          DrHint is <b>not a registered financial advisor, broker, dealer,
          bullion exchange, or lending institution</b>. Nothing on the site
          constitutes investment, loan, tax or legal advice, or a personal
          recommendation to buy or sell any financial product. Always consult a
          licensed financial professional and confirm the day's official rate
          in writing before transacting.
        </p>

        <h2 className="mt-8 text-xl font-bold">B. Utility Services Disclaimer — Bill Lookup Tools</h2>
        <p className="mt-2 text-muted-foreground">
          The DrHint utility bill checker (covering LESCO, IESCO, MEPCO, GEPCO,
          PESCO, HESCO, SEPCO, QESCO, FESCO, K-Electric, SNGPL, SSGC, PTCL,
          KWSB and related operators) operates as an <b>independent scraping
          and lookup framework</b>. DrHint has <b>no direct official
          affiliation, endorsement, sponsorship, partnership, or commercial
          relationship</b> with any state power distribution company, gas
          utility, telecom operator, water board, or government department in
          Pakistan or any other jurisdiction.
        </p>
        <p className="mt-2 text-muted-foreground">
          Brand names, logos and trademarks remain the exclusive property of
          their respective owners and are used here strictly for navigational
          and informational reference. For binding billing disputes, always
          contact the relevant utility provider directly.
        </p>

        <h2 className="mt-8 text-xl font-bold">C. Not a real-time trading feed</h2>
        <p className="mt-2 text-muted-foreground">
          Rates on this site update every 10 minutes and reflect indicative market prices. They are
          not intended for use in real-time trading, hedging, or large commercial transactions.
        </p>

        <h2 className="mt-8 text-xl font-bold">Local rates may differ</h2>
        <p className="mt-2 text-muted-foreground">
          Actual rates at your local Sarafa Bazaar, Bullion Association or jeweller may differ
          based on demand, taxation, making charges, and dealer-specific premiums. Always confirm
          the day's official rate in writing before making a purchase.
        </p>

        <h2 className="mt-8 text-xl font-bold">No investment advice</h2>
        <p className="mt-2 text-muted-foreground">
          Articles and guides on this site discuss gold buying and investing in general terms.
          Nothing on the site is a personal recommendation, financial advice, or solicitation to
          buy or sell any financial product. Consult a licensed financial adviser before making
          investment decisions.
        </p>

        <h2 className="mt-8 text-xl font-bold">No warranty</h2>
        <p className="mt-2 text-muted-foreground">
          We make no warranties about the completeness, reliability or accuracy of any information
          on this site. Any action you take based on the information here is strictly at your own
          risk.
        </p>
      </article>
    </Layout>
  ),
});